
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { useEffect } from "react";

const MentionsLegales = () => {
  useEffect(() => {
    console.log("MentionsLegales component rendered", {
      timestamp: new Date().toISOString(),
      url: window.location.href,
      hash: window.location.hash,
      pathname: window.location.pathname
    });
  }, []);

  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <main className="flex-grow pt-24 pb-16">
        <div className="container mx-auto px-4">
          <h1 className="text-3xl font-bold mb-8">Mentions légales</h1>
          <div className="prose max-w-none">
            <p className="mb-4"><strong>Nom de l'association :</strong> ENFANTS DE LA REPUBLIQUE</p>
            <p className="mb-4"><strong>Adresse :</strong> 6 Rue Clément Marot, 75008 Paris</p>
            <p className="mb-4"><strong>Numéro de téléphone :</strong> 01 43 59 26 93</p>
            <p className="mb-4"><strong>Directeur de la publication (nom du président de l'association) :</strong> Frédéric Sebag</p>
            <p className="mb-6"><strong>Hébergeur :</strong><br />
            OVH<br />
            2, rue Kellermann, 59100 Roubaix<br />
            09 55 00 66 33</p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default MentionsLegales;
